import { render, staticRenderFns } from "./SendMessageDetails.vue?vue&type=template&id=6453006a&"
import script from "./SendMessageDetails.vue?vue&type=script&lang=js&"
export * from "./SendMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports